
<script context="module">

import { 
  VmDefaultControls,
  VmCaptionControl,
  VmControl,
  VmIcon,
  VmTooltip,
  VmControlGroup,
  VmControlSpacer,
  VmControls,
  VmCurrentTime,
  VmTime,
  VmEndTime,
  VmFullscreenControl,
  VmLiveIndicator,
  VmMuteControl,
  VmPipControl,
  VmPlaybackControl,
  VmScrim,
  VmScrubberControl,
  VmSlider,
  VmSettingsControl,
  VmTimeProgress,
  VmVolumeControl 
} from '@vime/core';

import { define } from '../lib';
  

define('vm-default-controls', VmDefaultControls);
define('vm-caption-control', VmCaptionControl);
define('vm-control', VmControl);
define('vm-icon', VmIcon);
define('vm-tooltip', VmTooltip);
define('vm-control-group', VmControlGroup);
define('vm-control-spacer', VmControlSpacer);
define('vm-controls', VmControls);
define('vm-current-time', VmCurrentTime);
define('vm-time', VmTime);
define('vm-end-time', VmEndTime);
define('vm-fullscreen-control', VmFullscreenControl);
define('vm-live-indicator', VmLiveIndicator);
define('vm-mute-control', VmMuteControl);
define('vm-pip-control', VmPipControl);
define('vm-playback-control', VmPlaybackControl);
define('vm-scrim', VmScrim);
define('vm-scrubber-control', VmScrubberControl);
define('vm-slider', VmSlider);
define('vm-settings-control', VmSettingsControl);
define('vm-time-progress', VmTimeProgress);
define('vm-volume-control', VmVolumeControl);
  
</script>

<script>
import { createEventDispatcher, onMount } from 'svelte';
import { setProp } from '../lib';

let __ref;
let __mounted = false;

const dispatch = createEventDispatcher();

let className;

export let style;
export { className as class };

export let activeDuration = 2750;
export let waitForPlaybackStart = false;
export let hideWhenPaused = false;
export let hideOnMouseLeave = false;
export let theme = undefined;
export let isMobile = false;
export let isLive = false;
export let isAudioView = false;
export let isVideoView = false;

export const ref = () => __ref;
export const getWebComponent = () => __ref;

onMount(() => { 
  

  __mounted = true; 
});



const onEvent = (e) => {
  e.stopPropagation();
  dispatch(e.type, e.detail);
};
</script>

<vm-default-controls 
  class={className}
  style={style}
  active-duration={activeDuration}
  wait-for-playback-start={waitForPlaybackStart}
  hide-when-paused={hideWhenPaused}
  hide-on-mouse-leave={hideOnMouseLeave}
  theme={theme}
  is-mobile={isMobile}
  is-live={isLive}
  is-audio-view={isAudioView}
  is-video-view={isVideoView}
  
  bind:this={__ref}
>
  <slot></slot>
</vm-default-controls>
  